import { Navigate, useLocation } from "react-router-dom";
import { automapPartnerPortalPath } from "../../constants/automapPartnerPortalConfig";

/** Legacy /partner/* URLs redirect into the AutoMapa Client View partner portal. */
export default function PartnerLegacyRedirect() {
  const location = useLocation();
  const suffix = location.pathname.replace(/^\/partner\/?/, "") || "dashboard";
  const target = automapPartnerPortalPath(suffix);
  const search = location.search || "";
  const hash = location.hash || "";

  return <Navigate to={`${target}${search}${hash}`} replace />;
}
